export const months = [
  'Janvier',
  'Février',
  'Mars',
  'Avril',
  'Mai',
  'Juin',
  'Juillet',
  'Août',
  'Septembre',
  'Octobre',
  'Novembre',
  'Décembre',
];

export const servicesName = [
  {
    singular: 'détourage',
    plural: 'détourages',
  },
  {
    singular: 'intégration',
    plural: 'intégrations',
  },
  {
    singular: 'animation 360°',
    plural: 'animations 360°',
  },
  {
    singular: 'pesée',
    plural: 'pesées',
  },
  {
    singular: 'couleur',
    plural: 'couleurs',
  },
];
